module.exports = __webpack_public_path__ + "img/sustainability-image@2x.3256ddf9.png";